export const ACCESSIBILITY = '/accessibility'
export const ACCOUNT = '/account'
export const ACCOUNT_EVENTS = `${ACCOUNT}/events`
export const ACCOUNT_INFO = `${ACCOUNT}/info`
export const ACCOUNT_PASSWORD_RESET = `${ACCOUNT}/password-reset`
export const ADD_REMOVE_ITEMS = '/start/add-remove-item'
export const BLACK_DESK = '/theblackdesk'
export const BLOG = '/blog/'
export const BUY_NEW = 'https://buy.theblacktux.com'
export const BUY_NEW_ACCESSORIES_SLUG = '/accessories'
export const BUY_NEW_COLLECTIONS = 'https://buy.theblacktux.com/collections'
export const BUY_NEW_CUFFLINKS_STUDS_SLUG = '/cufflinks-studs'
export const BUY_NEW_NECKWEAR_SLUG = '/neckwear'
export const BUY_NEW_SHIRTS_SLUG = '/shirts-1'
export const BUY_NEW_SHOES_SLUG = '/shoes'
export const BUY_NEW_SUITS_TUXEDOS_SLUG = '/suits-and-tuxedos'
export const BUY_NEW_VESTS_SLUG = '/vests'
export const CANCEL_APPOINTMENT = '/cancel-appointment/:appointmentId'
export const CAREERS = '/about/careers'
export const CHECKOUT = '/checkout'
export const COLLECTION_SUITS_SLUG = 'suits'
export const COLLECTION_TUXEDOS_SLUG = 'tuxedos'
export const COLLECTION_TUXEDOS_SUITS_SLUG = 'suits-tuxedos'
export const COLLECTION_SHIRTS_SLUG = 'shirts'
export const COLLECTION_VESTS_SLUG = 'vests'
export const COLLECTION_CUFFLINKS_STUDS_SLUG = 'cufflinks-studs'
export const COLLECTION_NECKWEAR_SLUG = 'neckwear-2'
export const COLLECTION_SHOES_SLUG = 'shoes'
export const COLLECTION_ACCESSORIES_SLUG = 'the-rest'

export const COLLECTIONS = '/collections'
export const COLLECTION_TUXEDOS_SUITS = `${COLLECTIONS}/${COLLECTION_TUXEDOS_SUITS_SLUG}`
export const COLLECTION_SUITS = `${COLLECTIONS}/${COLLECTION_SUITS_SLUG}`
export const COLLECTION_TUXEDOS = `${COLLECTIONS}/${COLLECTION_TUXEDOS_SLUG}`
export const COLLECTION_SHIRTS = `${COLLECTIONS}/${COLLECTION_SHIRTS_SLUG}`
export const COLLECTION_VESTS = `${COLLECTIONS}/${COLLECTION_VESTS_SLUG}`
export const COLLECTION_CUFFLINKS_STUDS = `${COLLECTIONS}/${COLLECTION_CUFFLINKS_STUDS_SLUG}`
export const COLLECTION_NECKWEAR = `${COLLECTIONS}/${COLLECTION_NECKWEAR_SLUG}`
export const COLLECTION_SHOES = `${COLLECTIONS}/${COLLECTION_SHOES_SLUG}`
export const COLLECTION_ACCESSORIES = `${COLLECTIONS}/${COLLECTION_ACCESSORIES_SLUG}`
export const DAVIDS_BRIDAL = '/davidsbridal'
export const STYLED_LOOKS = '/styled-looks'
export const EVENT = '/event'
export const EVENT_PAGE = `${EVENT}/:eventId`
export const eventPageUrl = (eventId) => EVENT_PAGE.replace(':eventId', eventId)
export const EVENT_SUMMARY = '/event-summary'
export const FAQ = '/faq'
export const FIT_GUARANTEE = '/fit-guarantee'
export const GARBAGE_SUITS = '/garbage-suits'
export const HELP_CENTER = 'https://help.theblacktux.com/hc/en-us'
export const HOME = '/'
export const HOME_TRY_ON = '/home-try-on'
export const HOW_IT_WORKS = '/how-it-works'
export const LEGAL = '/legal'
export const LOGOUT = `${ACCOUNT}/logout`
export const LOOKBUILDER = '/lookbuilder'
export const LOOKBUILDER_RENT_BUY = '/lookbuilder/rent-or-buy'
export const LOOKBUILDER_SUCCESS = '/lookbuilder/success'
export const LOST_AND_FOUND = '/start/lost-and-found'
export const ONBOARDING = '/onboarding'
export const NEW_ACCOUNT_SUCCESS = `${COLLECTION_TUXEDOS_SUITS}?newaccount=1`
export const NEW_HOME_PAGE = '/get-started'
export const NEW_RENT_TO_KEEP = `${EVENT}/:eventId/rent-to-keep`
export const ORDER = '/order'
export const ORDER_CONFIRMATION = `${ORDER}/:orderId/confirmation`
export const ORDER_DETAIL = `${EVENT}/:eventId${ORDER}/:orderId`
export const orderManagerPageUrl = (eventId, orderId) =>
  ORDER_DETAIL.replace(':eventId', eventId).replace(':orderId', orderId)
export const CATEGORY_PAGE = `/categories`
export const REMOVE_ITEMS_PAGE = `${ORDER_DETAIL}/remove-items`
export const ORIGIN = 'https://theblacktux.com'
export const OUR_QUALITY = '/our-quality'
export const OUR_STORY = '/about/story'
export const PRINT_RETURN_LABEL = '/assets/return_label_print.html'
export const PRINT_RETURN_LABEL_V2 = '/admin/_static_/return_label_print_v2.html'
export const PROM = `${BUY_NEW}/pages/prom-suits-and-tuxedos`
export const REAL_WEDDINGS = '/real-weddings'
export const RECEIPT = '/receipt'
export const RECEIPT_EVENT = `${RECEIPT}/:eventId`
export const RENTAL_AGREEMENT = '/rental-agreement'
export const RENTAL_EXTENSION = '/start/extended-rental'
export const RENT_TO_KEEP_PRICING = '/start/rtkpricing'
export const RENT_TO_KEEP = '/start/rtkform'
export const REPLACEMENTS = '/start/replacements'
export const RESET_PASSWORD = `${ACCOUNT}/reset-password`
export const RETURNS = '/start/return-items'
export const RETURN_POLICY = '/return-policy'
export const SALE_COLLECTION = '/sale'
export const SAMPLE_SALE_TERMS_OF_SERVICE =
  'https://samplesale.theblacktux.com/policies/terms-of-service'
export const SUBMIT_SOLVVY = '/submit-solvvy'
export const SURVEY = '/survey'
export const TUXEDO_SUIT_RENTAL = '/tuxedo-suit-rental'
export const STATIC_LOGIN = `${ACCOUNT}/login`
export const STATIC_REGISTRATION = `${ACCOUNT}/signup`
export const WEDDINGS_LP = '/wedding-tuxedos-suits'
export const WEDDINGS_LP_MANAGE_HASH = `${WEDDINGS_LP}#manage-wedding-party`

// Address Update
export const ADDRESS_UPDATE = `${ORDER_DETAIL}/address-update`
export const ADDRESS_DETAILS = `${ORDER_DETAIL}/address-details`

// OLD URLS Before URL Migration to Shopify conventions for PCP and PDP
export const COLLECTION = '/collection'
export const OLD_PRODUCT_CATEGORY = `${COLLECTION}/:displayCategory`
export const OLD_ADD_ITEMS_PRODUCT_CATEGORY = `/add-items${OLD_PRODUCT_CATEGORY}`
export const OLD_ADD_ITEMS_PRODUCT_DETAIL = `${OLD_ADD_ITEMS_PRODUCT_CATEGORY}:product`
export const OLD_PRODUCT_CATEGORY_BUY = `${OLD_PRODUCT_CATEGORY}/buy`
export const OLD_PRODUCT_CATEGORY_HTO = `${OLD_PRODUCT_CATEGORY}${HOME_TRY_ON}`
export const OLD_PRODUCT_DETAIL = `${OLD_PRODUCT_CATEGORY}/:product`
export const OLD_PRODUCT_DETAIL_BUY = `${OLD_PRODUCT_CATEGORY}/:product/buy`
export const OLD_PRODUCT_DETAIL_HTO = `${OLD_PRODUCT_CATEGORY}/:product${HOME_TRY_ON}`
export const OLD_PRODUCT_REVIEWS = `${COLLECTION}/:displayCategory/:product/reviews`

// Cart
export const CART_ADD_ITEM = `/add-items/cart`
export const CHECKOUT_ADD_ITEM = `/add-items/checkout`

// Fit

export const FIT_INTRO_SLUG = 'intro'
export const FIT_SUMMARY_SLUG = 'summary'
export const FIT_SIZES_SLUG = 'your-sizes'

export const FIT_LP = '/find-your-fit'
export const FIT = '/fit'
export const FIT_INTRO = `${FIT}/${FIT_INTRO_SLUG}`
export const FIT_SUMMARY = `${FIT}/${FIT_SUMMARY_SLUG}`
export const FIT_SIZES = `${FIT}/${FIT_SIZES_SLUG}`
export const FIT_BY_SLUG = `${FIT}/:slug`

export const PRODUCT = '/products'
export const PRODUCT_REVIEWS = '/products/:product/reviews'
export const GROOMS_GUIDE = '/collection/:displayCategory/grooms-guide'

export const PRODUCT_CATEGORY = '/collections/:displayCategory'
export const PRODUCT_CATEGORY_BUY = `${PRODUCT_CATEGORY}/buy`
export const PRODUCT_CATEGORY_HTO = `${PRODUCT_CATEGORY}${HOME_TRY_ON}`
export const ADD_ITEMS_PRODUCT = `/add-items${PRODUCT}`

export const PRODUCT_DETAIL = `/products/:product`
export const PRODUCT_DETAIL_BUY = `products/:product/buy`
export const PRODUCT_DETAIL_HTO = `products/:product${HOME_TRY_ON}`
export const ADD_ITEMS_PRODUCT_DETAIL = `${ADD_ITEMS_PRODUCT}/:product`

// Add Items Email Links
const ADD_ITEMS_EMAIL = `${EVENT}/:eventId${ORDER}/:orderId/add-items`
export const PRODUCT_CATEGORY_EMAIL = `${PRODUCT_CATEGORY}${ADD_ITEMS_EMAIL}`
export const PRODUCT_DETAIL_EMAIL = `${PRODUCT_DETAIL}${ADD_ITEMS_EMAIL}`

// Showroom

export const SHOWROOM = '/locations'
export const SHOWROOM_SLUG = `${SHOWROOM}/:slug`

// TODO: Rename and swap to production URL paths when ready to release
export const SHOWROOMS = '/showrooms'
export const SHOWROOMS_SEARCH = `${SHOWROOMS}/search`
export const SHOWROOMS_DETAIL = `${SHOWROOMS}/:showroomSlug`
export const SHOWROOMS_INTERSTITIAL = `${SHOWROOMS}/interstitial`
export const SHOWROOM_BOOK_APPOINTMENT_TYPE = `${SHOWROOMS_DETAIL}/bookappointment-type`
export const SHOWROOM_BOOK_APPOINTMENT_DATETIME = `${SHOWROOMS_DETAIL}/bookappointment-datetime`
export const SHOWROOM_BOOK_APPOINTMENT_LOGIN = `${SHOWROOMS_DETAIL}/bookappointment-login`
export const SHOWROOM_BOOK_APPOINTMENT_REGISTRATION = `${SHOWROOMS_DETAIL}/bookappointment-register`
export const SHOWROOM_BOOK_APPOINTMENT_EVENT_DETAILS = `${SHOWROOMS_DETAIL}/bookappointment-eventdetails`
export const SHOWROOM_BOOK_APPOINTMENT_THANK_YOU = `${SHOWROOMS_DETAIL}/bookappointment-thankyou`

// Query String Paramaters

// Would love to eventually write a helper function that constructs all/multiple
// filter queries once we get more implemented here
export const constructFilterUrl = (query) => `filter[${query}]`
export const HTO_FILTER_QUERY = `${constructFilterUrl('hto')}=enabled`
export const constructPcpHtoUrl = (basePath = '') => `${basePath}${HOME_TRY_ON}?${HTO_FILTER_QUERY}`
export const constructPdpHtoUrl = (basePath = '') => `${basePath}${HOME_TRY_ON}`
export const constructPdpBuyUrl = (basePath = '') => `${basePath}/buy`
export const TUXEDOS_SUITS_HTO = constructPcpHtoUrl(COLLECTION_TUXEDOS_SUITS)

// Veil

export const FEATURE_FLAGS = '/veil/features'

// External
export const AMAZON_GROOMS_GUIDE =
  'https://www.amazon.com/Grooms-Guide-Men-Verge-Marriage/dp/0998739995/'
export const LOST_ITEMS_FAQ = `${HELP_CENTER}/articles/115013960447-I-accidentally-returned-my-personal-item-s-in-my-box-Can-The-Black-Tux-help-me-`
export const PRESS_INQUIRIES_TYPEFORM = 'https://theblacktux.typeform.com/to/PUhTvo7t'
export const RETURNS_FAQ = `${HELP_CENTER}/articles/115012639468-How-and-where-do-I-return-my-rental-`
export const TAILORING_FAQ = `${HELP_CENTER}/articles/115008008167-Can-I-tailor-my-rental-`
export const PRIVACY_HOST = 'https://privacy.theblacktux.com'
export const PRIVACY = `${PRIVACY_HOST}/privacy-policy`
export const PRIVACY_CA_NOTICE = `${PRIVACY_HOST}#california-privacy-notice`
export const PRIVACY_OPT_OUT = `${PRIVACY_HOST}/opt-out`
export const GROOM_RENTS_FREE_FAQ = `${HELP_CENTER}/articles/360005214613-Do-you-offer-discounts-or-a-free-rental-for-the-groom-for-bringing-a-full-wedding-party-`
